import { alpha, darken, lighten } from "@mui/material";

export const customStyles = (theme) => `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

  :root {
    --primary-color: ${theme.palette.primary.main};
    --bg-app: ${theme.palette.background.paper};
    --bg-card: ${theme.palette.background.paper};
    --text-primary: ${theme.palette.text.primary};
    --text-secondary: ${theme.palette.text.secondary};
    --border-subtle: ${theme.palette.stroke.main};
    --row-odd: ${theme.palette.background.card};
    --row-even: ${theme.palette.background.paper};
    --row-hover: ${theme.palette.background.default};
    --header-bg: ${theme.palette.background.paper};
    --header-text: ${theme.palette.text.secondary};
    --input-bg:${theme.palette.background.textField};
    --error-text: ${theme.palette.error.main};
    --header-active-bg: ${theme.palette.background.paper};
    --header-active-text: ${theme.palette.text.primary};
    --action-edit: ${theme.palette.text.primary};
    --action-delete: ${theme.palette.error.main};
}
  .custom-table-wrapper .handsontable,
  .custom-table-wrapper .htCore,
  .custom-table-wrapper .wtHider,
  .custom-table-wrapper .wtSpreader,
  .custom-table-wrapper .ht_clone_top,
  .custom-table-wrapper .ht_clone_left,
  .custom-table-wrapper .ht_clone_corner,
  .custom-table-wrapper .ht_master .wtHolder {
    background-color: var(--bg-app) !important;
    border: none !important; 
  }
    
  .custom-table-wrapper { font-family: 'Inter', sans-serif; transition: background-color 0.3s ease; }
  .custom-table-wrapper .handsontable { border: none !important; overflow: hidden; }
  .ht_master .wtHider { border: none !important; color: var(--text-primary) !important; }

  .custom-table-wrapper .handsontable th {
    background-color: var(--header-bg);
    color: var(--header-text);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 2px solid var(--border-subtle);
    border-top: none; border-right: none !important; border-left: none !important;
    padding: 0px 5px; text-align: left; vertical-align: middle;
  }

  .custom-table-wrapper .handsontable td {
    border-top: 1px solid var(--border-subtle) !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid var(--border-subtle) !important;
    background-color: transparent !important;
    color: var(--text-primary) !important;
  }

  .error-cell { color: var(--error-text) !important; font-weight: 500; }

  .custom-table-wrapper .handsontable tbody tr:nth-of-type(odd) td,
  .custom-table-wrapper .handsontable tbody tr:nth-of-type(odd) th { background-color: var(--row-odd) !important; }
  .custom-table-wrapper .handsontable tbody tr:nth-of-type(even) td,
  .custom-table-wrapper .handsontable tbody tr:nth-of-type(even) th { background-color: var(--row-even) !important; }
  .custom-table-wrapper .handsontable tbody tr:hover td,
  .custom-table-wrapper .handsontable tbody tr:hover th { background-color: var(--row-hover) !important; }

  .htDropdownMenu, .htAutocomplete { background: var(--bg-card); padding: 4px; border: 1px solid var(--border-subtle); }
  .htDropdownMenu table.htCore td,  {
     background-color: var(--bg-card) !important; 
     color: var(--text-primary) !important; border: none; border-radius: 4px; 
     padding: 0 !important;
  }
  .htDropdownMenu table tbody tr td {
    padding: 0 !important;
  }

  .handsontableInput { background-color: var(--input-bg) !important; color: var(--text-primary) !important; font-family: 'Inter', sans-serif !important; font-size: 13px !important; }
  .handsontableInputHolder { background-color: var(--input-bg) !important; }

  .ht-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center; 
    height: 16px;
    padding: 0 10px;
    border-radius: 16px;
    font-size: 0.65rem;
    font-weight: 700;
    cursor: pointer; border: 1px solid transparent;
    transition: all 0.2s;
  }
  .ht-chip-success {
    background-color: ${alpha(theme.palette.success.main, 0.1)};
    color:  ${theme.palette.mode === "dark" ? lighten(theme.palette.success.main, 0.2) : darken(theme.palette.success.main, 0.3)};
    border-color: ${theme.palette.success.main};
    border-radius: 10px;
    }
  
  .ht-chip-error {
    background-color: ${alpha(theme.palette.error.main, 0.2)};
    color:  ${theme.palette.mode === "dark" ? lighten(theme.palette.error.main, 0.2) : darken(theme.palette.error.main, 0.3)};
    border: "0.1px solid ";
    border-color: ${theme.palette.error.main};
    border-radius: 10px;
  }
  .ht-chip-null {
    background-color:${alpha(theme.palette.chip.arquive, 0.3)};
    color:  ${theme.palette.mode === "dark" ? lighten(theme.palette.text.secondary, 0.6) : darken(theme.palette.text.secondary, 0.6)};
    border-color: var(--text-secondary);
    border-radius: 10px;
    opacity: 0.7;
  }
  .ht-chip-null:hover { opacity: 1; border-color: var(--text-secondary); }

  .action-cell-container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      height: 100%;
      width: 100%;
  }

  .action-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 4px;
      border-radius: 50%;
      transition: background-color 0.2s;
  }
  .action-btn:hover { background-color: rgba(0,0,0,0.05); }
  .action-btn.edit { color: var(--action-edit); }
  .action-btn.delete { color: var(--action-delete); }

  .custom-table-wrapper .handsontable th.ht__highlight {
    background-color: var(--header-active-bg) !important;
    color: var(--header-active-text) !important;
    border-bottom: 2px solid var(--header-active-text);
    transition: background-color 0.2s ease;
  }

  .custom-table-wrapper.view-mode .htAutocompleteArrow { display: none !important; }
  .custom-table-wrapper.view-mode .htAutocomplete { padding-right: 5px !important; }

.custom-table-wrapper .handsontable,
.custom-table-wrapper .handsontable thead,
.custom-table-wrapper .handsontable thead tr:first-child th {
  border-top: none !important;
}
.custom-table-wrapper .handsontable {
  --hot-selection-border-color: var(--primary-color);
}

.custom-table-wrapper .wtBorder {
  background-color: var(--primary-color) !important;
}
.custom-table-wrapper .handsontable td.area:before {
  background: var(--primary-color) !important;
}
  .htDropdownMenu, .htAutocomplete { 
    background: var(--bg-card) !important; 
    padding: 8px !important; 
    border: 1px solid var(--border-subtle) !important;
  }
  .handsontable a {
    color: var(--primary-color) !important;
  }
  .htDropdownMenu table.htCore, 
  .htDropdownMenu table.htCore td {
     background-color: var(--bg-card) !important; 
     color: var(--text-primary) !important; 
     border: none !important;
     border-radius:0px !important;
  }
  .htFiltersMenuButtons {
    border-top: 1px solid var(--text-disabled) !important;
    padding: 12px 4px 4px 4px !important;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .handsontable .htUIInput.htUIButton input[type="button"] {
    background-color: var(--input-bg) !important;
    color: ${theme.palette.text.primary} !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 6px 16px !important;
    font-weight: 600 !important;
  }

 .handsontable .htUIInput.htUIButtonOK input[type="button"] {
    background-color: var(--primary-color) !important;
    color: #fff !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 6px 16px !important;
    font-weight: 600 !important;
  }

.handsontable .htCheckboxRendererInput {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;  
  width: 16px;
  height: 16px;
  border: 2px solid var(--text-secondary) !important;
  border-radius: 3px;
  background-color: transparent;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
  outline: none;
  transition: all 0.2s ease;
  display: inline-block;
}

.handsontable .htCheckboxRendererInput:checked {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.handsontable .htCheckboxRendererInput:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

  .htUIInput input[type="text"] {
    background-color: var(--input-bg) !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--border-subtle) !important;
    border-radius: 4px !important;
    min-height: 30px !important;
    padding: 5px !important;
  }

  .htFiltersMenuValuePart a {
    color: var(--primary-color) !important;
    font-size: 11px !important;
    text-decoration: none !important;
  }
  .changeType {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--header-text) !important;
    margin-left: 4px !important;
    cursor: pointer;
  }
  .htFiltersActive .changeType {
    background-color: var(--primary-color) !important;
    color: #fff !important;
  }
  .custom-table-wrapper .handsontable {
    --hot-selection-border-color: var(--primary-color);
  }
  .custom-table-wrapper .wtBorder {
    background-color: var(--primary-color) !important;
  }
`;
